import { VStack } from '@vivaahealth/design-system';

import ReviewCard from './ReviewCard';

import * as store from '../../../reducers/store';
import { ReviewSection, SectionType } from '../../../utils/review';

interface ReviewCardsProps {
  fields: store.FormFieldWithConfig[];
  onEdit: (sectionType: SectionType) => void;
  sectionConfiguration: Record<SectionType, ReviewSection>;
}

export const ReviewCards = ({
  fields,
  sectionConfiguration,
  onEdit,
}: ReviewCardsProps) => {
  return (
    <VStack gap={16}>
      {Object.entries(sectionConfiguration).map(([type, configuration]) => {
        return (
          <ReviewCard
            sectionType={type as SectionType}
            key={type}
            fields={fields}
            sectionConfiguration={configuration}
            onEdit={onEdit}
          />
        );
      })}
    </VStack>
  );
};

export default ReviewCards;
